var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"scatter","height":"400","options":_vm.apexChatData.scatterChart.chartOptions,"series":_vm.apexChatData.scatterChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }